import PropTypes from 'prop-types';
export const sliderPropTypes = {
  slides: PropTypes.arrayOf(PropTypes.node),
  config: PropTypes.object,
  classname: PropTypes.string
};